import { B000120EigyoNm, catchRestError, RestClient } from "clients/rest";
import { getSCode, SakujoyoteiKbn } from "messages/codes";
import { UseFormReturn } from "react-hook-form";

export type B100040CreateRequest = {
  bumonCd: string;
  bumonNm: string;
  eigyoCd: string;
} & Partial<{
  bumonKana: string;
  bumonNmr: string;
  telNo: string;
  faxNo: string;
  sakujoyoteiKbn: string;
}>;

//新規登録処理
export const B100040Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100040CreateRequest = {
    bumonCd: fields.bumonCd,
    bumonNm: fields.bumonNm,
    bumonKana: fields.bumonKana,
    bumonNmr: fields.bumonNmr,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    eigyoCd: fields.eigyoCd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
  };

  return RestClient.post("b100040/create", data);
};

export type B100040UpdateRequest = {
  bumonCd: string;
  bumonNm: string;
  eigyoCd: string;
} & Partial<{
  bumonKana: string;
  bumonNmr: string;
  telNo: string;
  faxNo: string;
  sakujoyoteiKbn: string;
  version: string;
}>;

//更新処理
export const B100040Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100040UpdateRequest = {
    bumonCd: fields.bumonCd,
    bumonNm: fields.bumonNm,
    bumonKana: fields.bumonKana,
    bumonNmr: fields.bumonNmr,
    telNo: fields.telNo,
    faxNo: fields.faxNo,
    eigyoCd: fields.eigyoCd,
    sakujoyoteiKbn: fields.sakujoyoteiKbn!.value,
    version: fields.version,
  };

  return RestClient.put("b100040/update", data);
};

export type B100040GetRequest = {
  bumonCd: string;
};

export type B100040GetResponse = {
  bumonCd: string;
  bumonNm: string;
  bumonNmr: string;
  bumonKana: string;
  telNo: string;
  faxNo: string;
  eigyoCd: string;
  sakujoyoteiKbn: string;
  version: string;
};

export const B100040Get = (props: B100040GetRequest) => {
  return RestClient.get<B100040GetResponse>("b100040/get", {
    params: props,
  });
};

// 部門情報表示処理
export const B100040Bumon = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.bumonCd === "") {
    methods.setValue("bumonNm", "");
    methods.setValue("bumonKana", "");
    methods.setValue("bumonNmr", "");
    methods.setValue("telNo", "");
    methods.setValue("faxNo", "");
    methods.setValue("eigyoCd", "");
    methods.setValue("eigyoNm", "");
    methods.setValue("sakujoyoteiKbn", getSCode(SakujoyoteiKbn, "0"));
    methods.setValue("version", "");
    return;
  }
  await B100040Get({ bumonCd: data.bumonCd })
    .then((response) => {
      methods.setValue("bumonNm", response.data.bumonNm);
      methods.setValue("bumonKana", response.data.bumonKana);
      methods.setValue("bumonNmr", response.data.bumonNmr);
      methods.setValue("telNo", response.data.telNo);
      methods.setValue("faxNo", response.data.faxNo);
      methods.setValue("eigyoCd", response.data.eigyoCd);
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn)
      );
      methods.setValue("version", response.data.version);

      // 営業所名を取得
      B000120EigyoNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("bumonNm", "");
      methods.setValue("bumonKana", "");
      methods.setValue("bumonNmr", "");
      methods.setValue("telNo", "");
      methods.setValue("faxNo", "");
      methods.setValue("eigyoCd", "");
      methods.setValue("eigyoNm", "");
      methods.setValue("sakujoyoteiKbn", getSCode(SakujoyoteiKbn, "0"));
      methods.setValue("version", "");
    });
};
